import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 21v-2a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v2h-14","key":"svg-0"}],["path",{"d":"M10 16v-5h-4v-4h4v-4h4v4h4v4h-4v5","key":"svg-1"}]]

const IconGrave = createReactComponent('outline', 'grave', 'Grave', __iconNode);

export default IconGrave;